import axiosInstance, { getDefaultRequestConfig } from './base/axios.client';

export async function getCurrentTypes(locale?: string): Promise<any> {
  return await axiosInstance.get(
    '/current-types',
    getDefaultRequestConfig(locale)
  );
}
